import HAEditUser from './HAEditUser';

export default HAEditUser;
